import React from 'react';
import {useSelector} from 'react-redux';
import {ErrorBoundary} from 'react-error-boundary';
import {FOOTER_HEIGHT, HEADER_HEIGHT, SIDEBAR_WIDTH} from '../../conf/SMCConsts';
import {showSidebarSelector} from '../../store/selectors/view.selectors';
import SMCMainFooterErrorBoundary from './SMCMainFooter/SMCMainFooterErrorBoundary';

function AppCompnentsPlacer({
    Header,
    Sidebar,
    Body,
    Footer
}) {
    const showSidebar  = useSelector(showSidebarSelector);
    const sidebarWidth = showSidebar ? SIDEBAR_WIDTH : 0;
    const bodyWidth    = showSidebar ? `calc(100vw - ${SIDEBAR_WIDTH}px)` : `calc(100vw)`;

    return (
        <div id="MainPageDiv" style={{ width: "100%", height: "100%", display: 'flex', flexDirection: 'column' }}>
            <div style={{ height: HEADER_HEIGHT, minHeight: HEADER_HEIGHT }}>
                <Header />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', height: `calc(100vh - ${HEADER_HEIGHT+FOOTER_HEIGHT}px)` }}>
                <div style={{ height: `calc(100vh - ${HEADER_HEIGHT+FOOTER_HEIGHT+22}px)`, width: sidebarWidth, minWidth: sidebarWidth}}>
                    <Sidebar />
                </div>
                <div style={{ height: "100%", width: bodyWidth, overflow: 'auto' }}>
                    <Body />
                </div>
            </div>
            <div style={{ height: FOOTER_HEIGHT, minHeight: FOOTER_HEIGHT }}>
                <ErrorBoundary FallbackComponent={SMCMainFooterErrorBoundary}>
                    <Footer />
                </ErrorBoundary>
            </div>
        </div>
    );
}

export default AppCompnentsPlacer;